<div class="request-status-loading request-status-container" *ngIf="status === 0">
  <div class="status-icon">
    <!-- <i class="anticon anticon-loading anticon-spin"></i> -->
    <img src="/assets/status/loading.svg" alt />
  </div>
  <div class="status-title">{{ modal.loadingText | translate }}</div>
</div>

<div class="request-status-success request-status-container" *ngIf="status === 1">
  <div class="status-icon">
    <!-- <i class="anticon anticon-check-circle"></i> -->
    <img src="/assets/status/success.svg" alt />
  </div>
  <div class="status-title">{{ modal.successText | translate }}</div>
  <div class="status-footer">
    <button nz-button [nzSize]="'large'" [nzType]="'primary'" (click)="createAccount()">
      {{ "channel.continue_to_enter_account" | translate }}
      <!-- 继续录入账号 -->
    </button>
    <!-- <button
      nz-button
      [nzSize]="'large'"
      [nzType]="'primary'"
      (click)="toSync()">
      同步该账号房源
    </button> -->
    <button nz-button [nzSize]="'large'" (click)="cancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
  </div>
</div>

<div class="request-status-error request-status-container" *ngIf="status === 2">
  <div class="status-icon">
    <!-- <i class="anticon anticon-close-circle"></i> -->
    <img src="/assets/status/fail.png" alt />
  </div>
  <div class="status-title">
    {{ modal.failText | translate }}
    <p class="subtitle">{{ modal.failSubText | translate }}</p>
  </div>
  <div class="status-footer">
    <!-- <button nz-button [nzSize]="'large'" (click)="displayCustomerModal()">
      {{ "word.contact_2" | translate }} -->
    <!-- 联系客服 -->
    <!-- </button> -->
    <button nz-button [nzSize]="'large'" nzType="primary" (click)="retry()">
      {{ "channel.login_again" | translate }}
      <!-- 再次登录 -->
    </button>
  </div>
</div>
<div class="request-status-airlock request-status-container" *ngIf="status === 3">
  <ng-container *ngIf="lockType === LockType.AIRBNB">
    <div class="status-title">
      {{ "channel.choose_airbnb_verification_mode" | translate }}
      <!-- 按照Airbnb的要求，您需要验证当前账号 -->
    </div>
    <div class="btn-group">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="airlock.verify_types.phone_verification_via_call"
        (click)="sendAirlockCode('phone_verification_via_call')"
      >
        {{ "channel.lock.give_me_a_call" | translate }}
        <!-- 给我打电话 -->
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="airlock.verify_types.phone_verification_via_text"
        (click)="sendAirlockCode('phone_verification_via_text')"
      >
        {{ "channel.lock.text_message_verification" | translate }}
        <!-- 短信验证 -->
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="airlock.verify_types.email_code_verification"
        (click)="sendAirlockCode('email_code_verification')"
      >
        {{ "channel.lock.email_verification" | translate }}
        <!-- 邮箱验证 -->
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        nzType="primary"
        *ngIf="airlock.verify_types.push_code_verification"
        (click)="sendAirlockCode('push_code_verification')"
      >
        {{ airlock.verify_types.push_code_verification }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="lockType === LockType.CTRIP">
    <div class="status-title">
      {{ "channel.choose_booking_verification_mode" | translate }}
    </div>
    <div class="btn-group">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="ctriplock.email"
        (click)="sendBookingCode('email')"
      >
        {{ "channel.lock.email_verification" | translate }}
        <!-- 邮件验证码 -->
      </button>
      <button nz-button [nzSize]="'large'" [nzType]="'primary'" *ngIf="ctriplock.sms" (click)="sendBookingCode('sms')">
        {{ "channel.lock.text_message_verification_code" | translate }}
        <!-- 短信验证码 -->
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="lockType === LockType.MEITUAN">
    <div class="status-title">您需要验证当前账号</div>
    <div class="btn-group">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        [nzLoading]="sendBtnLoading"
        (click)="sendMeituanCode()"
      >
        {{ "channel.lock.text_message_verification_code" | translate }}
        <!-- 短信验证码 -->
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="lockType === LockType.ZHENGUO">
    <div class="status-title">按照榛果的要求，请您选择验证方式</div>
    <div class="btn-group">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="zhenguolock.sms"
        (click)="sendZhenguoCode('sms')"
      >
        短信验证码
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="zhenguolock.birthday"
        (click)="sendZhenguoCode('birthday')"
      >
        出生日期
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="zhenguolock.filledname"
        (click)="sendZhenguoCode('filledname')"
      >
        银行卡持卡人姓名
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="zhenguolock.lbs"
        (click)="sendZhenguoCode('lbs')"
      >
        与您相关的地址
      </button>
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        *ngIf="zhenguolock.buying"
        (click)="sendZhenguoCode('buying')"
      >
        您曾经购买过的项目
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="lockType === LockType.AIRBNB_GEETEST">
    <div class="status-title">
      {{ "channel.airbnb_manual_verification" | translate }}
      <!-- 按照爱彼迎的要求，请您手动进行人工验证 -->
    </div>
    <div class="airbnb-geetest-container" style="width: 300px; margin: 0 auto"></div>
  </ng-container>
  <ng-container *ngIf="lockType === LockType.AIRBNB_BROWSER_VERIFY">
    <div class="airbnb-browser-verify">
      <div class="title">
        <img src="/assets/icon/airbnb_icon.png" />
        <!-- 您需要完成验证 -->
        <p>{{ "channel.airbnb_need_browser_verify" | translate }}</p>
      </div>
      <div class="step">
        <!-- 第1步： -->
        <p>{{ "channel.airbnb_browser_verify_1" | translate }}</p>
        <!-- 点击此链接打开爱彼迎进行验证 > -->
        <a [href]="airbnbBrowserVerifyInfo.url" target="_blank">
          {{ "channel.airbnb_browser_verify_1_info" | translate }} ></a
        >
      </div>
      <div class="step">
        <!-- 第2步： -->
        <p>{{ "channel.airbnb_browser_verify_2" | translate }}</p>
        <!-- 完成验证后，点击“继续”按钮。 -->
        <p class="step-info">
          {{ "channel.airbnb_browser_verify_2_info" | translate }}
        </p>
      </div>
      <div class="footer">
        <button nz-button nzType="primary" class="button" (click)="loginAfterAirbnbBrowserVerify()">
          <!-- 继续 -->
          {{ "word.continue" | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>

<div class="request-status-verify-code request-status-container" *ngIf="status === 4">
  <div class="status-title">
    {{ "word.verify_code" | translate }}
    <!-- 验证码 -->
  </div>
  <div class="input-wrapper">
    <ng-container *ngIf="lockType === LockType.AIRBNB">
      <input type="text" nz-input nzSize="large" [(ngModel)]="inputCode" />
    </ng-container>
    <ng-container *ngIf="lockType === LockType.CTRIP || lockType === LockType.ZHENGUO || lockType === LockType.MEITUAN">
      <input type="text" nz-input nzSize="large" [(ngModel)]="inputCode" />
    </ng-container>
  </div>
  <div class="status-footer">
    <ng-container *ngIf="lockType === LockType.AIRBNB">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        [disabled]="!inputCode.length"
        [nzLoading]="postBtnLoading"
        (click)="postAirlockCode()"
      >
        {{ "channel.submit" | translate }}
        <!-- 提交 -->
      </button>
    </ng-container>
    <ng-container *ngIf="lockType === LockType.CTRIP">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        [disabled]="!inputCode.length"
        [nzLoading]="postBtnLoading"
        (click)="postBookingCode()"
      >
        {{ "channel.submit" | translate }}
        <!-- 提交 -->
      </button>
    </ng-container>
    <ng-container *ngIf="lockType === LockType.ZHENGUO">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        [disabled]="!inputCode.length"
        [nzLoading]="postBtnLoading"
        (click)="postZhenguoCode()"
      >
        {{ "channel.submit" | translate }}
        <!-- 提交 -->
      </button>
    </ng-container>

    <ng-container *ngIf="lockType === LockType.MEITUAN">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        [disabled]="!inputCode.length"
        [nzLoading]="postBtnLoading"
        (click)="postMeituanCode()"
      >
        {{ "channel.submit" | translate }}
        <!-- 提交 -->
      </button>
    </ng-container>
  </div>
</div>
<div class="request-status-verify-code request-status-container" *ngIf="status === 5">
  <div class="status-title">
    {{ "word.verify_code" | translate }}
    <!-- 验证码 -->
  </div>
  <div class="input-wrapper">
    <ng-container>
      <p><img [src]="captchaUrl" style="width: 100px; height: 40px; vertical-align: middle; margin: 0 auto" /></p>
      <input type="text" nz-input nzSize="small" [(ngModel)]="captchaCode" />
    </ng-container>
  </div>
  <div class="status-footer">
    <ng-container *ngIf="lockType === LockType.MEITUAN">
      <button
        nz-button
        [nzSize]="'large'"
        [nzType]="'primary'"
        [disabled]="!captchaCode.length"
        [nzLoading]="sendBtnLoading"
        (click)="sendMeituanCode()"
      >
        {{ "channel.submit" | translate }}
        <!-- 提交 -->
      </button>
    </ng-container>
  </div>
</div>

<div class="request-status-verify-code request-status-container" *ngIf="status === 10">
  <!-- 输入生日 -->
  <div class="birthday" *ngIf="verifyType === 'birthday'">
    <p style="font-size: 20px">{{ zhenguolock?.question }}</p>
    <span>如19900101</span>

    <div class="input" style="width: 50%; margin: 20px auto">
      <input nz-input type="text" nzPlaceHolder="请输入您的生日" [(ngModel)]="zhenguoVerifyValue" />
    </div>
  </div>

  <!-- 银行卡持有人姓名 -->
  <div class="filledname" *ngIf="verifyType === 'filledname'">
    <p style="font-size: 20px">{{ zhenguolock?.question }}</p>
    <span> 姓名：{{ (zhenguolock?.filledname)[0]?.desc }} </span>

    <div class="input" style="width: 50%; margin: 20px auto">
      <input nz-input type="text" nzPlaceHolder="请输入被隐藏掉的**部分的名字" [(ngModel)]="zhenguoVerifyValue" />
    </div>
  </div>
  <!-- 地址 -->
  <div class="lbs" *ngIf="verifyType === 'lbs'">
    <p style="font-size: 20px">{{ zhenguolock?.question }}</p>

    <div class="input" style="width: 80%; margin: 20px auto 0">
      <nz-radio-group [(ngModel)]="zhenguoVerifyValue" style="width: 100%">
        <div class="item" style="width: 50%; float: left; margin-bottom: 20px" *ngFor="let item of zhenguolock.lbs">
          <label nz-radio [nzValue]="item.code">
            <span>{{ item.desc }}</span>
          </label>
        </div>
      </nz-radio-group>
    </div>
  </div>
  <!-- 购买过的项目 -->
  <div class="buying" *ngIf="verifyType === 'buying'">
    <p style="font-size: 20px">{{ zhenguolock?.question }}</p>

    <div class="input" style="width: 80%; margin: 20px auto 0">
      <nz-radio-group [(ngModel)]="zhenguoVerifyValue" style="width: 100%">
        <div class="item" style="width: 50%; float: left; margin-bottom: 20px" *ngFor="let item of zhenguolock.buying">
          <label nz-radio [nzValue]="item.code">
            <img
              [src]="item.image"
              style="
                padding-left: 0;
                padding-right: 0;
                width: 40px;
                height: 40px;
                vertical-align: middle;
                margin: 0 5px;
              "
            />
            <span>{{ item.desc }}</span>
          </label>
        </div>
      </nz-radio-group>
    </div>
  </div>

  <button
    nz-button
    [nzSize]="'large'"
    [nzType]="'primary'"
    [disabled]="zhenguoVerifyValue === undefined"
    [nzLoading]="postBtnLoading"
    (click)="postZhenguoCode()"
  >
    {{ "channel.submit" | translate }}
    <!-- 提交 -->
  </button>
</div>

<ng-template #douyinSliderIframe>
  <iframe class="w-full h-[400px]" *ngIf="douyinSliderIframeUrl" [src]="douyinSliderIframeUrl" frameborder="0"></iframe>
</ng-template>

<!-- <ng-template #customerService>
  <div class="qrcode">
    <p>请使用微信扫码添加客服微信号回复您的问题</p>
    <p>客服小易将会为您解答</p>
    <img src="/assets/icon/wechat-xiaoyi.jpg">
    <p class="bottom">微信扫码添加客服微信【BJYHostex】</p>
  </div>
</ng-template> -->
